export default __webpack_public_path__ + "model-customization589f43.png";